<template lang="html">
  <transition name="toggle-navigation">
    <div class="navigation" id="nav">
      <button class="close-button" v-on:click="handleNavToggle">
        <svg width="14" height="14" xmlns="http://www.w3.org/2000/svg">
          <g fill="none" fill-rule="evenodd">
            <path
              fill="#000"
              d="M.636 11.95L11.95.636l1.414 1.414L2.05 13.364z"
            />
            <path
              fill="#000"
              d="M2.05.636L13.364 11.95l-1.414 1.414L.636 2.05z"
            />
            <path d="M-2-2h18v18H-2z" />
          </g>
        </svg>
      </button>
      <nav class="main-navigation">
        <ul class="main-navigation__list">
          <li class="main-navigation__item">
            <router-link to="/" v-on:click.native="handleNavToggle"
              >Introduction</router-link
            >
          </li>
          <li class="main-navigation__item">
            <router-link to="/stops" v-on:click.native="handleNavToggle"
              >Stops</router-link
            >
          </li>
          <li class="main-navigation__item">
            <router-link to="/map" v-on:click.native="handleNavToggle"
              >Exhibition Map</router-link
            >
          </li>
          <li class="main-navigation__item">
            <router-link to="/info" v-on:click.native="handleNavToggle"
              >Information</router-link
            >
          </li>
        </ul>
      </nav>
      <ul class="lang-toggle">
        <li class="lang-toggle__item"></li>
        <!-- <li class="lang-toggle__item">
          <button class="lang-button" @click="handleLangChange" data-language="en" v-bind:class="{ active: activeLang == 'en' }">
            English
          </button>
        </li>
        <li class="lang-toggle__item">
          <button class="lang-button" @click="handleLangChange" data-language="zh_Hant_HK" v-bind:class="{ active: activeLang == 'zh_Hant_HK' }">
            中文
          </button>
        </li> -->
        <!-- <li class="lang-toggle__item">
          <button class="lang-button" @click="handleLangChange" data-language="auslan" v-bind:class="{ active: activeLang == 'auslan' }">
            AUSLAN
          </button>
        </li> -->
      </ul>
    </div>
  </transition>
</template>

<script>
// import { mapState } from 'vuex'

export default {
  name: "Navigation",
  data() {
    return {
      activeLang: this.$store.state.currentLang
    };
  },
  methods: {
    handleNavToggle() {
      this.$store.dispatch("toggleNavigation");
    },
    handleLangChange(event) {
      var element = event.target;
      var newLang = element.getAttribute("data-language");

      this.activeLang = newLang; // update active class
      this.$store.dispatch("updateLanguage", newLang); //update global lang.
      this.handleNavToggle();
    }
  }
  // mounted() {
  //   document.body.classList.add("no-scroll");
  // },
  // beforeDestroy() {
  //   document.body.classList.remove("no-scroll");
  // }
};
</script>

<style lang="scss" scoped>
.navigation {
  z-index: 200;
  background-color: white;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;

  opacity: 1;
  transform: translateY(0);

  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.close-button {
  cursor: pointer;
  border: none;
  background: none;
  // width: 16px;
  width: 100vw;
  height: 40px;
  padding-right: 15px;
  // text-align: right;
  display: grid;
  justify-content: flex-end;
  align-items: center;
}
.main-navigation {
  text-align: center;
}
.main-navigation__list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.main-navigation__item {
  > a {
    text-decoration: none;
    @include ngv-type($exhibition-subtitle, 24px, 27px);
  }

  margin: 1em 0;
}

.toggle-navigation-enter-active,
.toggle-navigation-leave-active {
  transition: transform 0.3s, opacity 0.3s;
}
.toggle-navigation-enter, .toggle-navigation-leave-to /* .toggle-navigation-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(100%);
}

.lang-toggle {
  margin: 0;
  padding: 1em 0;
  text-align: center;
}
.lang-toggle__item {
  margin: 0 2px;
  padding: 0;
  display: inline-block;
}
.lang-button {
  margin: 0 auto;

  border: 1px solid gray;
  border-radius: 78px;
  background-color: white;
  color: black;

  // padding: 1em; // messes up buttons in Safari!

  width: 86px;
  height: 34px;

  text-decoration: none;
  display: flex;
  justify-content: center;
  align-items: center;

  @include ngv-type($exhibition_subtitle, 14px, 18px);
  font-weight: bold;

  transition: 0.3s ease;

  &.active {
    background-color: black;
    border-color: black;
    color: white;
  }

  &:hover {
    background-color: rgba(black, 0.8);
    border-color: rgba(black, 0.8);
    color: white;
  }

  &:disabled {
    background-color: #efefef;
    border-color: rgba(black, 0.3);
    color: rgba(black, 0.3);
  }
}
</style>
